// Copyright ©️ 2026 eVolve MEP, LLC

import type { Facility, StrongOmit } from '@evolvemep/api-ts';

import { useFacilityRequired } from 'components/Mantine/GlobalFilters/FacilityRequired';
import { FacilitySelect } from 'components/Mantine/GlobalFilters/FacilitySelect';
import type { SearchableSelectProps } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableSelect';

export type Props = StrongOmit<
  SearchableSelectProps<'shop/facility', Facility, 'facilityId'>,
  'idKey' | 'paginatedGet' | 'getItemLabel' | 'value' | 'onChange'
> & {
  onChange?: (facility: Facility | null) => void;
};

export const GlobalFacilitySelect = ({ onChange, ...props }: Props) => {
  const { selectedFacility, setSelectedFacility } = useFacilityRequired();

  return (
    <FacilitySelect
      onChange={(v) => {
        setSelectedFacility(v);
        onChange?.(v);
      }}
      value={selectedFacility}
      {...props}
    />
  );
};
